import { useEffect, useState } from "react";
import styled from "styled-components";
import { PageButton } from "../styled/input/Input";
import CircularLoader from "../styled/loaders/CircularLoader";
import Toast from "../hooks/Toast";
import {
  checkAssetsExist,
  migrateAssetsToFirebase,
} from "../utils/migrateAssets";

export const AdminButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const MigrationButton = styled(PageButton)`
  background-color: #222739;
  display: grid;
  place-content: center;
  min-width: 132px;
  min-height: 44px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #1b1f2d;
  }

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.7;
  }
`;

const AssetMigrationButton = ({ onComplete }) => {
  const [isMigrating, setIsMigrating] = useState(false);
  const [assetsExist, setAssetsExist] = useState(null);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState(" ");
  const [toastType, setToastType] = useState(undefined);

  useEffect(() => {
    checkAssetsExist().then(setAssetsExist);
  }, []);

  async function handleMigration() {
    setIsMigrating(true);

    const result = await migrateAssetsToFirebase();

    if (result.success) {
      setAssetsExist(true);
      setToastType("success");
      setToastMessage(
        `Synced ${result.count} assets (${result.breakdown.Crypto} crypto, ${result.breakdown.Stocks} stocks, ${result.breakdown.Currencies} forex)`
      );
      onComplete?.(result);
    } else {
      setToastType("error");
      setToastMessage(result.message);
    }

    setOpenToast(true);
    setIsMigrating(false);
  }

  return (
    <>
      {openToast && (
        <Toast
          open={{ openToast, setOpenToast }}
          message={toastMessage}
          type={toastType}
        />
      )}

      <MigrationButton
        onClick={handleMigration}
        className={isMigrating ? "disabled" : undefined}
      >
        {isMigrating ? (
          <CircularLoader bg="rgba(12, 108, 243, 0.2)" size="24" color="#fff" />
        ) : (
          <p>{assetsExist ? "Re-sync assets" : "Sync assets"}</p>
        )}
      </MigrationButton>
    </>
  );
};

export default AssetMigrationButton;
